/**
 * User formatting utilities for audit logs
 */

import { isEmptyString } from '@/utils/string';

export interface UserWithName {
  first_name?: string;
  last_name?: string;
  email: string;
}

/**
 * Get the display name for a user (full name if available, otherwise email)
 * Returns just the name part without email in parentheses
 */
export function getUserDisplayName(user: UserWithName): string {
  const firstName = user.first_name?.trim() ?? '';
  const lastName = user.last_name?.trim() ?? '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  return !isEmptyString(fullName) ? fullName : user.email;
}

/**
 * Get display name with email in parentheses (if name available)
 * Returns "Full Name (email)" if name available, otherwise just email
 */
export function getUserDisplayNameWithEmail(user: UserWithName): string {
  const name = getUserDisplayName(user);
  return name === user.email ? name : `${name} (${user.email})`;
}

/**
 * Format user name from user object
 * Returns "Full Name (email)" if name available, otherwise just email
 * @deprecated Use getUserDisplayNameWithEmail instead
 */
export function formatUserName(user: UserWithName): string {
  return getUserDisplayNameWithEmail(user);
}
